// oncare-frontend/src/hooks/useFetchSchedules/useScheduleForTomorrow.js
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { useSelector } from "react-redux"
import { usePermissionsList } from "../queries/usePermissions"

import { getDateFormatted, getFirstOpenDateTomorrow } from "../../utils/generalUtils"
import {
	filterPatientScheduleForEditedPatients,
	filterNurseScheduleForEditedNurses,
	filterEditedPatients,
	filterEditedNurses
} from "../../utils/mongoUtils"
import useFetchSettings from "../useFetchSettings"

/**
 *
 * @returns
 */
const useScheduleForTomorrow = (componentName = "default") => {
	const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()

	const testEnvironment = user.org_id === "org_lkg3WMhi3Q2l92iT"

	const { settingsData } = useFetchSettings()
	const isEditing = useSelector(state => state.schedule.isEditing)
	const permissionsData = usePermissionsList()

	const documentId = useSelector(state => state.tomorrow.documentId)
	const currentPatientSchedule = useSelector(state => state.tomorrow.patientSchedule)
	const currentNurseSchedule = useSelector(state => state.tomorrow.nurseSchedule)
	const editedPatients = useSelector(state => state.tomorrow.editedPatients)
	const editedNurses = useSelector(state => state.tomorrow.editedNurses)

	const enabled = !!(
		isAuthenticated &&
		!isEditing &&
		settingsData &&
		settingsData.centerOpen &&
		settingsData.centerOpen.length > 0 &&
		permissionsData &&
		permissionsData.includes("read:schedules")
	)

	const queryFn = async () => {
		const centerClosedDates = settingsData?.center_closed_dates || []
		const date = getDateFormatted(
			getFirstOpenDateTomorrow(settingsData?.centerOpen, testEnvironment, centerClosedDates)
		)

		const token = await getAccessTokenSilently({
			audience: process.env.REACT_APP_API_IDENTIFIER
		})
		const response = await axios.post(
			`${process.env.REACT_APP_BACKEND_URL}/api/get-schedule`,
			{
				documentId,
				date,
				currentPatientSchedule:
					filterPatientScheduleForEditedPatients(
						currentPatientSchedule,
						editedPatients
					) || [],
				currentNurseSchedule:
					filterNurseScheduleForEditedNurses(currentNurseSchedule, editedNurses) || [],
				editedPatients: filterEditedPatients(editedPatients) || [],
				editedNurses: filterEditedNurses(editedNurses) || []
			},
			{
				headers: { Authorization: `Bearer ${token}` }
			}
		)
		return response.data.payload
	}

	const { data, isLoading, error } = useQuery({
		queryKey: ["scheduleTomorrow", componentName],
		queryFn,
		enabled,
		refetchInterval: 1000 * 60 * 10 // Refetch every 10 minutes
	})

	return { data, isLoading, error }
}

export default useScheduleForTomorrow